import { useState, useEffect, useCallback, RefObject } from "react";

export const useFilterPortalPosition = (
  triggerRef: RefObject<HTMLDivElement | null>
) => {
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null);

  const computePosition = useCallback(() => {
    if (!triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    setPos({ top: rect.bottom + 4, left: rect.left });
  }, [triggerRef]);

  useEffect(() => {
    computePosition();
    window.addEventListener("scroll", computePosition, true);
    window.addEventListener("resize", computePosition);
    return () => {
      window.removeEventListener("scroll", computePosition, true);
      window.removeEventListener("resize", computePosition);
    };
  }, [computePosition]);

  return pos;
};
